export default __webpack_public_path__ + "eye-off.svg";